exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.el-tag[data-v-c9d03bf6] {\n  margin-right: 10px;\n  margin-bottom: 10px;\n}\n.button-new-tag[data-v-c9d03bf6] {\n  height: 32px;\n  line-height: 30px;\n  padding-top: 0;\n  padding-bottom: 0;\n}\n.input-new-tag[data-v-c9d03bf6] {\n  width: 90px;\n  margin-bottom: 10px;\n  vertical-align: bottom;\n}\n.link[data-v-c9d03bf6] {\n  cursor: pointer;\n}\n", ""]);

// exports
